import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (url: string, key: string) => {
    setSelected(key);
    setIsOpen(false);
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const selectedCategory = categories.find(c => c.key === selected);

  return (
    <div className="relative w-full max-w-md mx-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border-2 border-primary-300/60 rounded-lg text-foreground-800 font-medium hover:border-primary-400 transition-colors"
      >
        <span className="flex items-center gap-2">
          <i className="ri-apps-line text-primary-500"></i>
          <span>
            {selectedCategory ? t(selectedCategory.nameKey) : t('categories_all')}
          </span>
        </span>
        <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 rounded-lg border border-background-200/70 shadow-xl max-h-80 overflow-y-auto z-50">
          <div className="p-2">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => handleSelect(cat.url, cat.key)}
                className="w-full flex items-center gap-3 px-4 py-2.5 rounded-md text-left text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                <i className={`${cat.icon} text-primary-400 w-5 h-5 flex items-center justify-center`}></i>
                <span className="flex-1">{t(cat.nameKey)}</span>
                <i className="ri-external-link-line text-foreground-400 text-xs"></i>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}